<template>
  <div>
    <div class="my_order_detail comBox" style="margin-top: 0.7rem">
      <div style="font-size: 0.2rem; margin-bottom: 0.2rem; margin-top: 0.2rem">
        确认订单信息
      </div>
      <div class="my_order_detail_box">
        <div class="left">
          <!-- border="1" -->
          <table class="my_order_detail_table">
            <tr>
              <th style="text-align: left; padding-left: 0.2rem">商品信息</th>
              <th>数量</th>
              <th>价格</th>
            </tr>
            <template v-for="(item, index) in list">
              <tr>
                <td>
                  <div class="td_left">
                    <div style="width: 1.58rem;height:height: 0.94rem;">
                      <img style="
                          width: 1.58rem;
                          height: 0.94rem;
                          border-radius: 8px;
                        " :src="item.materialDto.showImage" />
                    </div>
                    <div class="td_left_content">
                      <div style="font-size: 0.14rem; color: #333333">
                        {{ item.materialDto.title }}
                      </div>
                      <div style="font-size: 0.12rem; color: #86909c">
                        <div v-if="item.authType == 'SELF'" style="color: #86909c; font-size: 0.12rem;margin-top: 8px;"
                          class="typeName">
                          个人授权
                        </div>
                        <div v-if="item.authType == 'ENTERPRISE'" style="color: #86909c; font-size: 0.12rem"
                          class="typeName">
                          企业授权
                        </div>
                        <div v-if="item.authType == 'UNION'" style="color: #86909c; font-size: 0.12rem;" class="typeName">
                          联盟授权
                        </div>
                      </div>
                      <!-- <div style="font-size: 0.14rem">
                        <span style="color: #86909c">单价：</span>
                        <span style="color: #333333"
                          >￥{{ (item.salePrice / 1).toFixed(2) }}</span
                        >
                      </div> -->
                    </div>
                  </div>
                </td>
                <td style="width: 12%; text-align: center">1</td>
                <td style="width: 10%">
                  <div style="display: flex; justify-content: center">
                    <span style="font-size: 0.14rem; color: #C01A26">￥{{ (item.payPrice / 1).toFixed(2) }}</span>
                    <!-- <span
                      style="
                        font-size: 0.14rem;
                        color: #86909c;
                        text-decoration: line-through;
                        margin-left: 0.1rem;
                      "
                      >￥{{ (item.salePrice / 1).toFixed(2) }}</span
                    > -->
                  </div>
                </td>
              </tr>
            </template>
          </table>
          <div>
            <!-- <div style="font-size: 0.16rem; color: #333333; margin-top: 0.2rem">
              授权信息
            </div> -->
            <!-- <div class="leftItem">
							{{
								list.length > 0 && list[0].authInfo ? list[0].authInfo : '无'
							}}</div> -->
            <!-- <div class="leftItem">
              请仔细核对视频授权范围，个人授权仅可用于个人自媒体/短视频等，不能用于企业行为。购买后，在订单页面填写授权证书获取授权
            </div> -->
          </div>
          <div style="margin-bottom: 0.2rem">
            <div style="font-size: 0.16rem; color: #333333; margin-top: 0.2rem">
              发票信息
            </div>

            <div class="leftItem">
              {{
                list.length > 0 && list[0].invoiceInfo
                ? list[0].invoiceInfo
                : "无"
              }}
            </div>
            <!-- <div class="leftItem">{{ item.invoiceInfo }}</div> -->
          </div>
          <div style="margin-bottom: 0.2rem">
            <div style="font-size: 0.16rem; color: #333333; margin-top: 0.2rem">
              授权信息
            </div>
            <div class="leftItem">
              {{
                list.length > 0 && list[0].authInfo ? list[0].authInfo : "无"
              }}
            </div>
          </div>
        </div>
        <div class="right_">
          <!-- <div class="rightItem">
            <span>商品价格：</span>
            <span style="color: #333333">￥{{ (totalPay / 1).toFixed(2) }}</span>
          </div> -->
          <div class="rightItem">
            <span>商品数量：</span>
            <span style="color: #333333">x{{ list.length }}</span>
          </div>
          <div class="rightItem">
            <span>合计：</span>
            <span style="color: #C01A26; font-size: 0.2rem">￥{{ (totalPay / 1).toFixed(2) }}</span>
          </div>
          <div class="payBnt" @click="gotoPay('/myOrderCheckstand')">
            立即下单
          </div>
          <div>
            音频、视频、图片素材，一经售出概不退换，购买即代表同意
            <span style="color: #C01A26" @click="openagreement('yyfwxy')">《素材库》</span>、<span style="color: #C01A26"
              @click="openagreement('fwxy')">《免责声明》</span>协议
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { useRoute, useRouter } from "vue-router";

const router = useRouter();
const route = useRoute();
let type = route.query.type;
const list = ref({});
const totalPay = ref(0.0);
const totalPay2 = ref(0.0);
if (type == "car") {
  //购物车进入
  var getList = function () {
    Axios(
      "get",
      "/fodder/car/index/" + route.query.arry,
      false,
      false,
      function (res) {
        list.value = res.data.data;
        let sum = 0;
        let sum2 = 0;
        list.value.forEach((item) => {
          sum += 1 * item.payPrice;
          sum2 += 1 * item.salePrice;
        });
        totalPay.value = sum.toFixed(2);
        totalPay2.value = sum2.toFixed(2);
      }
    );
  };
} else {
  //其它进入
  let id = route.query.arry;
  let authType = route.query.authType;
  var getList = function () {
    Axios(
      "post",
      "/fodder/order/index",
      {
        materialId: id,
        authType: authType,
      },
      false,
      function (res) {
        let data = res.data.data;
        list.value = [data];
        totalPay.value = data.payPrice.toFixed(2);
        totalPay2.value = data.payPrice.toFixed(2);
      }
    );
  };
}
getList();

//直接跳转
const gotoPay = (url) => {
  if (type == "car") {
    //购物车进入
    // 购物车下单
    let orderArray = [];
    Axios(
      "post",
      "/fodder/car/create-orders/" + route.query.arry,
      {},
      false,
      (res) => {
        let data = res.data.data;
        data.forEach((item, index) => {
          orderArray.push(item.id);
        });
        let query = orderArray.join(",");
        router.push({
          path: url,
          query: {
            arry: query,
            totalPay: totalPay.value,
            type: type,
          },
        });
      }
    );
  } else {
    let id = route.query.arry;
    let authType = route.query.authType;
    Axios(
      "post",
      "/fodder/order",
      {
        materialId: id,
        authType: authType,
      },
      false,
      (res) => {
        let data = res.data.data;
        router.push({
          path: url,
          query: {
            arry: data.id,
            totalPay: data.price,
            type: type,
          },
        });
      }
    );
  }
};
const openagreement = (val) => {
  window.open(`/agreement?name=${val}`, "_bank");
};
</script>

<style scoped lang="less">
@import url(/src/assets/css/com.css);

.my_order_detail {
  margin: 0 auto;

  .leftItem {
    padding: 0.1rem 0.16rem;
    background: #f2f3f5;
    box-sizing: border-box;
    margin-top: 0.12rem;
    font-size: 0.14rem;
  }
}

.my_order_detail_box {
  display: flex;
  justify-content: space-between;

  .left {
    width: calc(100% - 3.4rem - 0.4rem);
    // background: #ccc;

    .my_order_detail_table {
      width: 100%;
      border: 1px solid #e3e6ec;

      .td_left {
        display: flex;
        justify-content: space-between;

        .td_left_content {
          width: calc(100% - 1.58rem - 0.12rem);
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
      }

      th {
        background: #e3e6ec;
        padding: 0.08rem 0;
        color: #333333;
        font-size: 0.14rem;
        box-sizing: border-box;
        // border:1px solid #E3E6EC;
      }

      td {
        padding: 0.12rem 0.2rem;
        box-sizing: border-box;
      }
    }
  }

  .right_ {
    width: 3.4rem;
    height: 2.85rem;
    border: 1px solid #e5e6eb;
    opacity: 1;
    color: #86909c;
    margin-left: 0.4rem;
    padding: 0.18rem 0.24rem 0.24rem;
    box-sizing: border-box;
    line-height: 0.2rem;
  }

  .rightItem {
    font-size: 0.14rem;
    color: #86909c;
    margin-top: 0.16rem;
    display: flex;
    justify-content: space-between;
  }

  .payBnt {
    width: 2.92rem;
    height: 0.45rem;
    background: #C01A26;
    border-radius: 0.08rem;
    opacity: 1;
    color: #fff;
    line-height: 0.45rem;
    font-size: 0.14rem;
    text-align: center;
    margin-top: 0.26rem;
    margin-bottom: 0.26rem;
    cursor: pointer;
  }
}
</style>
